import { createSelector } from '@reduxjs/toolkit';

import { vehicleLandingFacetField } from 'Addons/fitmentSearch/vehicleLandingFacetField';
import type { ReduxStateType } from 'Core/store';
import { Vehicle } from 'Models/index';

import { garageDataSelector, selectedVehicleSelector } from './index';

export const isPageLoadedWithVehicleInUriSelector = (state: ReduxStateType): boolean =>
  state.fitmentSearch.isPageLoadedWithVehicleInUri;

export const isVehicleLandingFacetSelectedSelector = (state: ReduxStateType): boolean =>
  state.search.request.selection.some((v) => v.field === vehicleLandingFacetField);

export function createVehicleIsSelectedSelector(vehicle: Vehicle): (state: ReduxStateType) => boolean {
  return createSelector(selectedVehicleSelector, (selectedVehicle) => vehicle.equals(selectedVehicle));
}

export const createSelectedVehicleSelectionSelector = createSelector(
  selectedVehicleSelector,
  (vehicle) => vehicle.selection,
);

export const createVehicleFromUriSelector = createSelector(
  (state: ReduxStateType) => state.fitmentSearch,
  (fitmentSearch) => fitmentSearch.vehicleFromUri,
);

export const garageSizeSelector = (state: ReduxStateType): number => garageDataSelector(state).size;

export const garageEmptySelector = (state: ReduxStateType): boolean => !garageSizeSelector(state);
